
import AuthService from './AuthService';
import ROUTES from './ApiRoutes';

const Auth = new AuthService();

const ApiCoreV2 = {
    // Endpoint con doble uso. Si no tiene params, devuelve todas las soluciones. Si tiene params, devuelve las soluciones específicas para ese problema
    getWizardConfig: function (orderID, params, type = null) { return Auth.get((ROUTES.core_v2.get_wizard_config + (type ? `?problem=${type}` : '')).replace('{id}', orderID), params) },

    resolveWizard: function (params) { return Auth.post(ROUTES.core_v2.resolve_wizard, params); },

    getWizardSummary: function (orderID, params) { return Auth.post((ROUTES.core_v2.summary).replace('{id}', orderID), params) },

    // Inventory

    getInventoryDashboard: function (params) {
        return Auth.get(ROUTES.inventory.get_inventory_dashboard, params);
    },

    getProductsPets: function (id, params) {
        return Auth.get(ROUTES.inventory.get_products_pets.replace('{id}', id), params);
    },

    getInventoryStockConfigValues: function (params) {
        return Auth.get(ROUTES.inventory.get_stock_config_values, params);
    },

    updateStockConfig: function (params) {
        return Auth.post(ROUTES.inventory.update_stock_config, params);
    },

    getEanProductsByPet: function (params) {
        return Auth.get(ROUTES.core_v2.products.get_eans_by_pet, params);
    },

    Petshops: {
        getOrders: function (params) {
            return Auth.get(ROUTES.petshops.get_orders, params);
        },
        getPackingOrderStatuses: function (params) {
            return Auth.get(ROUTES.petshops.get_packing_order_statuses, params);
        },
        getTransportOrderStatuses: function (params) {
            return Auth.get(ROUTES.petshops.get_transport_order_statuses, params);
        },
        generateLabels: function (params) {
            return Auth.post(ROUTES.petshops.generate_labels, params, { responseType: 'blob' });
        },
        repackage: function (params) {
            return Auth.post(ROUTES.petshops.repackage, params, { responseType: 'blob' });
        }
    },

    Addresses: {
        getLocalities: function (params) {
            return Auth.get(ROUTES.addresses.get_localities, params);
        },
        getNeighborhoods: function (params) {
            return Auth.get(ROUTES.addresses.get_neighborhoods, params);
        }
    },

    Customer: {
        changePackingOrderStatus: function (params) {
            return Auth.post(ROUTES.customer.change_packing_order_status, params);
        },
        changeTransportOrderStatus: function (params) {
            return Auth.post(ROUTES.customer.change_transport_order_status, params);
        }
    },

    DeliveryDrivers: {
        getDrivers: function (params) {
            return Auth.get(ROUTES.delivery_drivers.get_drivers, params);
        }
    },

    DeliveryTimes: {
        getDeliveryTimes: function (params) {
            return Auth.get(ROUTES.delivery_times.get_delivery_times, params);
        }
    },

    Supplier: {
        getPriceConfigValues: function (params) {
            return Auth.get(ROUTES.supplier.get_price_config_values, params);
        },
        updatePriceConfig: function (params) {
            return Auth.post(ROUTES.supplier.update_price_config, params);
        },
        bulkUpdatePriceConfig: function (params) {
            return Auth.post(ROUTES.supplier.bulk_update_price_config, params);
        }
    },

    TransportOrders: {
        completeDeliveryProcess: function (params) { return Auth.post(ROUTES.core_v2.transportOrders.complete_delivery_process, params); }
    }
};

export default ApiCoreV2;
